import script from "./accidentInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./accidentInput.vue?vue&type=script&setup=true&lang=ts"

import "./accidentInput.vue?vue&type=style&index=0&id=18a5e53f&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18a5e53f"]])

export default __exports__